module.exports = __webpack_public_path__ + "img/offers.daily.f6b03389.png";